var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 4 11",
    width: 4,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.86133 6.94434h-1.64063l-.232419-6.897465h2.105469zm-.82031 1.08007c.33268 0 .59928.09799.7998.29395.20508.19596.30762.44661.30762.75195 0 .30078-.10254.54916-.30762.74512-.20052.19597-.46712.29397-.7998.29397-.32813 0-.59473-.098-.79981-.29397-.20052-.19596-.30078-.44434-.30078-.74512s.10026-.54915.30078-.74511c.20508-.20053.47168-.30079.79981-.30079z",
    fill: "#f12a3a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkIcon);
export default __webpack_public_path__ + "static/media/exclamationMarkIcon.e2af02bb14d366ecdfa5a9ad64999a6a.svg";
export { ForwardRef as ReactComponent };